var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.vk_common_visible),expression:"vk_common_visible"}],class:_vm.keyboardClass})}
var staticRenderFns = []

export { render, staticRenderFns }